var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0.799805C1.55228 0.799805 2 1.24752 2 1.7998V5.5998H5.8C6.35228 5.5998 6.8 6.04752 6.8 6.5998C6.8 7.15209 6.35228 7.5998 5.8 7.5998H1C0.447715 7.5998 0 7.15209 0 6.5998V1.7998C0 1.24752 0.447715 0.799805 1 0.799805Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01656 2.39284C6.60151 -0.178031 10.5743 -0.73383 13.7661 1.0306C16.9624 2.79755 18.6048 6.4654 17.7945 10.0265C16.9841 13.5877 13.9162 16.1836 10.27 16.3935C6.62388 16.6033 3.27843 14.3765 2.06483 10.9319C1.88131 10.411 2.15481 9.83991 2.67571 9.65639C3.19661 9.47287 3.76766 9.74637 3.95118 10.2673C4.86878 12.8718 7.39827 14.5555 10.1551 14.3968C12.912 14.2381 15.2316 12.2753 15.8443 9.58276C16.457 6.89019 15.2152 4.11694 12.7985 2.78095C10.3817 1.44497 7.37277 1.86831 5.41851 3.81927C5.41137 3.8264 5.40413 3.83341 5.39678 3.84032L1.68478 7.32832C1.2823 7.70651 0.649442 7.68682 0.27125 7.28434C-0.106942 6.88186 -0.0872528 6.24901 0.315226 5.87081L4.01656 2.39284Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate-left.88ba359cd5560400b6f94e1aba64372d.svg";
export { ForwardRef as ReactComponent };